module.exports = __webpack_public_path__ + "static/media/tax-planning.c1ecdf6f.png";